import LanguagePageReducer from './LanguagePageReducer';

export default from './LanguagePageContainer';

export const LanguagePageReducers = {
  LanguagePageReducer,
};
